// src/pages/StripeRefreshPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStripeOnboardingLink } from '../../redux/therapistSlice'

function StripeRefreshPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(3);
  
  const { onboardingUrl, loading, error } = useSelector((state) => state.stripe);

  useEffect(() => {
    const getNewLink = async () => {
      try {
        await dispatch(getStripeOnboardingLink()).unwrap();
      } catch (error) {
        console.error('Error getting onboarding link:', error);
      }
    };

    getNewLink();
  }, [dispatch]);

  useEffect(() => {
    if (onboardingUrl) {
      // Countdown başlat
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      // 3 saniye sonra redirect
      const redirectTimer = setTimeout(() => {
        window.location.href = onboardingUrl;
      }, 3000);

      return () => {
        clearInterval(timer);
        clearTimeout(redirectTimer);
      };
    }
  }, [onboardingUrl]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        
        {/* Loading State */}
        {loading && !onboardingUrl && (
          <div className="text-center">
            <div className="mx-auto w-16 h-16 mb-6">
              <svg className="animate-spin h-16 w-16 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Preparing Setup Link...
            </h1>
            <p className="text-gray-600">
              Please wait while we generate a new setup link for you.
            </p>
          </div>
        )}

        {/* Ready to Redirect State */}
        {onboardingUrl && !loading && (
          <div className="text-center">
            <div className="mx-auto w-16 h-16 mb-6 bg-blue-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Redirecting to Setup...
            </h1>
            <p className="text-gray-600 mb-6">
              You'll be redirected to complete your Stripe account setup.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-blue-800">
                Redirecting in <span className="font-bold text-blue-600">{countdown}</span> seconds...
              </p>
            </div>
            <button
              onClick={() => window.location.href = onboardingUrl}
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Continue Now
            </button>
          </div>
        )}

        {/* Error State */}
        {error && !loading && (
          <div className="text-center">
            <div className="mx-auto w-16 h-16 mb-6 bg-red-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-1.963-1.333-2.732 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Something Went Wrong
            </h1>
            <p className="text-gray-600 mb-4">
              We couldn't generate a new setup link.
            </p>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-red-800">{error}</p>
            </div>
            <div className="space-y-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate('/TherapistHomePage')}
                className="w-full bg-gray-200 text-gray-800 py-3 px-6 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Return to Dashboard
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default StripeRefreshPage;
